import {PureComponent} from 'react';
import PropTypes from 'prop-types';
import toast from 'react-hot-toast';

// Global flash message tracker to prevent duplicates
window.flashMessageTracker = window.flashMessageTracker || {
  messages: new Map(), // Maps message content to timestamp
  cleanupInterval: null
};

const FLASH_MESSAGE_TIMEOUT = 8000; // 8 seconds to match slightly longer than toast duration

export default class FloatCallout extends PureComponent {
  componentDidMount() {
    this.showFlashMessage();
  }

  showFlashMessage = () => {
    const {type, text} = this.props;
    const messageKey = `${type}:${text}`;
    const now = Date.now();
    const tracker = window.flashMessageTracker;

    // Check if this exact message was shown recently
    if (tracker.messages.has(messageKey)) {
      const lastShown = tracker.messages.get(messageKey);
      if (now - lastShown < FLASH_MESSAGE_TIMEOUT) {
        // Message was shown recently, skip it
        return;
      }
    }

    // Show the message and track it
    if (type === 'error') {
      toast.error(text, {
        duration: 7500,
        id: messageKey // Use content as ID to prevent exact duplicates
      });
    }
    else if (type === 'success') {
      toast.success(text, {
        duration: 7500,
        id: messageKey // Use content as ID to prevent exact duplicates
      });
    }

    // Track this message
    tracker.messages.set(messageKey, now);

    // Set up cleanup if not already running
    if (!tracker.cleanupInterval) {
      tracker.cleanupInterval = setInterval(() => {
        const currentTime = Date.now();
        for (const [key, timestamp] of tracker.messages.entries()) {
          if (currentTime - timestamp > FLASH_MESSAGE_TIMEOUT) {
            tracker.messages.delete(key);
          }
        }

        // Stop cleanup if no messages to track
        if (tracker.messages.size === 0) {
          clearInterval(tracker.cleanupInterval);
          tracker.cleanupInterval = null;
        }
      }, 1000); // Cleanup every second
    }
  };

  render() {
    return null;
  }
}

FloatCallout.propTypes = {
  text: PropTypes.string.isRequired,
  timeout: PropTypes.string,
  type: PropTypes.oneOf(['error', 'success']).isRequired
};